module.exports = __webpack_public_path__ + "media/images/icon_interact_industry-468b550b1895987fc9d32b3ebb4d4cca.png";